export default __webpack_public_path__ + "static/media/diamond-color-2@3x.dd29b648.png";